'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _activities = require('../actions/activities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchActivitiesReservations),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(activitiesSaga);

function fetchActivitiesReservations(action) {
  var activitiesReservationsAPI, authToken, culture, header, queryString, response;
  return _regenerator2.default.wrap(function fetchActivitiesReservations$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          activitiesReservationsAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          queryString = 'toDate=' + action.payload.to + '&fromDate=' + action.payload.from + '&PageSize=' + action.payload.PageSize + '&PageNumber=' + action.payload.PageNumber + '&PatientKey=' + action.payload.PatientKey;
          _context.next = 7;
          return activitiesReservationsAPI.get(_webUtils.Urls.reservationSearch + '?' + queryString, header);

        case 7:
          response = _context.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context.next = 13;
            break;
          }

          _context.next = 11;
          return (0, _effects.put)((0, _activities.getActivitiesReservationsSuccess)(_extends({}, response.data, action.payload)));

        case 11:
          _context.next = 15;
          break;

        case 13:
          _context.next = 15;
          return (0, _effects.put)((0, _activities.getActivitiesReservationsFail)(_extends({}, action.payload)));

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function activitiesSaga() {
  return _regenerator2.default.wrap(function activitiesSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_activities.ACTIVITIES.ACTIVITIES_RESERVATION.LOAD, fetchActivitiesReservations);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

exports.default = activitiesSaga;
module.exports = exports['default'];